import React from "react";
import { Check, Edit, FileOutput } from "lucide-react";
import { usePromptGeneratorContext } from "@/components/feature/promptGenerator/hooks";
import * as analytics from "@/services/analytics";
import { clsx } from "clsx";

interface PromptGeneratorImprovedPromptProps {
  improvedPrompt: string;
  isWorking: boolean;
}

export const PromptGeneratorImprovedPrompt: React.FC<PromptGeneratorImprovedPromptProps> = ({
  isWorking,
  improvedPrompt,
}) => {
  const [isEdit, setIsEdit] = React.useState(false);
  const [isSent, setIsSent] = React.useState(false);
  const [editedImprovedPrompt, setEditedImprovedPrompt] = React.useState(improvedPrompt);
  const { sendPromptToChat } = usePromptGeneratorContext();

  React.useEffect(() => {
    if (improvedPrompt) {
      setEditedImprovedPrompt(improvedPrompt);
    }
  }, [improvedPrompt]);

  if (!improvedPrompt) {
    return;
  }

  const handleSendToChat = () => {
    setIsSent(true);
    analytics.improvePromptSendToChat(editedImprovedPrompt);
    sendPromptToChat(editedImprovedPrompt);
  };

  const handleEdit = () => {
    setIsEdit(prev => !prev);
  };

  return (
    <div className="mb-4">
      <div
        className={clsx(
          "relative mb-4 whitespace-pre-line rounded-lg border border-gray-200 bg-white p-5 text-sm shadow-md",
          {
            "border-2 border-gray-500": isEdit,
          },
        )}
        contentEditable={!isSent && isEdit}
        onBlur={t => setEditedImprovedPrompt(t.currentTarget.innerHTML)}
      >
        {improvedPrompt}
      </div>
      {!isWorking && (
        <div className="flex justify-end">
          <button
            onClick={handleEdit}
            className="mr-1 mt-2 flex items-center self-end rounded-md bg-white px-2 py-1 text-xs text-gray-600 shadow-sm transition-colors hover:bg-gray-100"
          >
            <Edit
              size={12}
              className={clsx("mr-1", {
                "text-green-500": isEdit,
              })}
            />
            Edit
          </button>
          <button
            onClick={handleSendToChat}
            className="mt-2 flex items-center self-end rounded-md bg-white px-2 py-1 text-xs text-gray-600 shadow-sm transition-colors hover:bg-gray-100"
          >
            {isSent ? (
              <>
                <Check size={12} className="mr-1 text-green-500" />
                Sent
              </>
            ) : (
              <>
                <FileOutput size={12} className="mr-1" />
                Send to Chat
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
};
